import {BASE_URL} from '@config'


/**
 * 获取文章列表
 * @type {{headers: {"Content-Type": string}, method: string, url: string, timeout: number}}
 */
export const GET_ARTICLE_LIST = {
    url: `${BASE_URL}/article/getList`,
    method: 'get',
    headers: {
        'Content-Type': 'application/json'
    },
    timeout: 30000
}

/**
 * 获取文章详情
 * @type {{headers: {"Content-Type": string}, method: string, url: string, timeout: number}}
 */
export const GET_ARTICLE_DETAIL = {
    url: `${BASE_URL}/article/view`,
    method: 'get',
    headers: {
        'Content-Type': 'application/json'
    },
    timeout: 30000
}


/**
 * 发送评论
 * @type {{}}
 */
export const CREATE_COMMENT = {
    url: `${BASE_URL}/comment/create`,
    method: 'post',
    headers: {
        'Content-Type': 'application/json'
    },
    timeout: 30000
}

/**
 * 获取评论列表
 * @type {{headers: {"Content-Type": string}, method: string, url: string, timeout: number}}
 */
export const GET_COMMENT_LIST = {
    url: `${BASE_URL}/comment/getList`,
    method: 'get',
    headers: {
        'Content-Type': 'application/json'
    },
    timeout: 30000
}

/**
 * 获取标签列表
 * @type {{headers: {"Content-Type": string}, method: string, url: string, timeout: number}}
 */
export const GET_TAG_LIST = {
    url: `${BASE_URL}/tag/getList`,
    method: 'get',
    headers: {
        'Content-Type': 'application/json'
    },
    timeout: 30000
}

/**
 * 获取时间线
 * @type {{headers: {"Content-Type": string}, method: string, url: string, timeout: number}}
 */
export const GET_TIMELINE = {
    url: `${BASE_URL}/article/timeline`,
    method: 'get',
    headers: {
        'Content-Type': 'application/json'
    },
    timeout: 30000
}

/**
 * 订阅
 * @type {{headers: {"Content-Type": string}, method: string, url: string, timeout: number}}
 */
export const SUBSCRIBE = {
    url: `${BASE_URL}/subscribe`,
    method: 'post',
    headers: {
        'Content-Type': 'application/json'
    },
    timeout: 30000
}

/**
 * 确认订阅
 * @type {{headers: {"Content-Type": string}, method: string, url: string, timeout: number}}
 */
export const CONFIRM_SUBSCRIBE = {
    url: `${BASE_URL}/confirm-subscribe`,
    method: 'post',
    headers: {
        'Content-Type': 'application/json'
    },
    timeout: 30000
}

/**
 * 取消订阅
 * @type {{headers: {"Content-Type": string}, method: string, url: string, timeout: number}}
 */
export const UNSUBSCRIBE = {
    url: `${BASE_URL}/unsubscribe`,
    method: 'post',
    headers: {
        'Content-Type': 'application/json'
    },
    timeout: 30000
}